import {slideUp, slideToggle} from "../../helpers";

export default () => {
  const blocks = document.querySelectorAll('.wp-block-faq');
  if(blocks[0]) {
    blocks.forEach(function (block) {
      const topics = block.querySelectorAll('.topic');

      topics.forEach(function (topic) {
        let title = topic.querySelector('.faq-title');

        title.addEventListener('click', function (event) {
          let index = event.target.getAttribute('data-index');
          let content = topic.querySelector(`.faq-content[id="${index}"]`);
          let currentTopic = block.querySelector(`.topic[data-index="${index}"]`);
          let otherTopics = block.querySelectorAll(`.topic:not([data-index="${index}"])`);

          otherTopics.forEach((topic) => {
            let content = topic.querySelector(`.faq-content`);
            if (topic.classList.contains('is-active')) {
              slideUp(content);
              topic.classList.remove('is-active');
            }
          })

          slideToggle(content);
          currentTopic.classList.toggle('is-active');
        })
      })
    });
  }
}
